import { combineReducers } from 'redux';

import cancelOrderChangesWarning from './cancelOrderChangesWarning';
import miniTrolley from './miniTrolley';
import multiSearch from './multiSearch';
import postcodeBanner from '[theme-lib]/apps/header/reducers/postcodeBanner';
import search from './search';

export default combineReducers({
  cancelOrderChangesWarning,
  miniTrolley,
  multiSearch,
  postcodeBanner,
  search,
});
